// extracted by mini-css-extract-plugin
export var errorIcon = "_o2-1";
export var nameLogo = "_o2-0";